import { IIconProps } from '../../types/IconProps.interface'

export const IconWarningCircle = ({ color = 'white' }: IIconProps) => {
  return (
    <svg fill='none' height='15' viewBox='0 0 15 15' width='15' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.5 1.31134e-06C11.6421 2.03558e-06 15 3.35787 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 -2.03557e-06 11.6421 -1.31134e-06 7.5C-3.29404e-07 3.35786 3.35786 8.44819e-07 7.5 1.31134e-06ZM7.5 1C3.91015 1 1 3.91015 0.999999 7.5C0.999998 11.0899 3.91015 14 7.5 14C11.0898 14 14 11.0899 14 7.5C14 3.91015 11.0899 1 7.5 1ZM7.5 9.75C7.91421 9.75 8.25 10.0858 8.25 10.5C8.25 10.9142 7.91421 11.25 7.5 11.25C7.08578 11.25 6.75 10.9142 6.75 10.5C6.75 10.0858 7.08578 9.75 7.5 9.75ZM7.5 4C7.77614 4 8 4.22386 8 4.5L8 7.5C8 7.77614 7.77614 8 7.5 8C7.22386 8 7 7.77614 7 7.5L7 4.5C7 4.22386 7.22386 4 7.5 4Z'
        fill={color}
      />
    </svg>
  )
}
